module.exports = {"title":"NAPs Table | Tipping Service | Racing Post","meta":[{"name":"description","content":"Discover the Racing Post NAPs table that details the most confident racing tips of the day sorted by leading tipsters across various publications."}]}


//////////////////
// WEBPACK FOOTER
// ./src/js/napsTable/meta.json
// module id = 2292
// module chunks = 0